import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../Store/AuthContext";
import AllservicePlansBox from "./AllservicePlansBox";
import axios from "axios";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function CatServiceRows({ catid, serid }) {
  const { userID, RendomTokenfetch, userRoll } = useAuth();
  const [error, setError] = useState(null);

  const [Allplans, setAllplans] = useState([]);
  // console.log(Allplans);
  const [loading, setLoading] = useState(false);

  const FetchAllplans = useCallback(async () => {
    setAllplans([]);
    try {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("role_id", userRoll);
      fdata.append("cat_id", catid);
      fdata.append("service_id", serid);
      fdata.append("subservice_id", "");
      fdata.append("state_id", "");
      fdata.append("city_id", "");
      fdata.append("limit", "5");
      fdata.append("limittype", "0");

      const response = await axios.post(`${WebsiteAPIurl}getAllPlan`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
        },
      });
      if (response.data.Status === "1") {
        setAllplans(response.data.plandata);
      } else {
        setAllplans([]);
      }
    } catch (error) {
      setError(error);
      console.error("Error fetching Plans:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, userID, catid, serid, userRoll]);

  useEffect(() => {
    FetchAllplans();
  }, [FetchAllplans]);

  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 12;
  const totalPages = Math.ceil(Allplans.length / questionsPerPage);
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentPlans = Allplans.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (error) {
    return alert(error);
  }

  return (
    <>
      <div className="row pt-4">
        {currentPlans.length > 0 ? (
          currentPlans.map((value, index) => (
            <AllservicePlansBox
              key={index}
              planid={value.id}
              planimage={value.image}
              title={value.title}
              planslug={value.slug}
              selling_price={value.selling_price}
              price={value.price}
              service_tag={value.feature_tag}
            />
          ))
        ) : (
          <>
            <div className="text-center fs-4">Data Not Found!</div>
          </>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls text-center mt-5">
          <button
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            ◄
          </button>
          {pageNumbers.map((number, index) => (
            <button
              key={index}
              className={`pagination-btn ${
                number === currentPage ? "active" : ""
              }`}
              onClick={() => number !== "..." && setCurrentPage(number)}
              disabled={number === "..."}
            >
              {number}
            </button>
          ))}
          <button
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            ►
          </button>
        </div>
      )}
    </>
  );
}
